import { Dispatch, RefObject, SetStateAction, useEffect, useMemo } from 'react';

import { Box } from '@mui/material';
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { useQueryProdutosModal } from 'pages/compra/configuracao-pedido/hooks';
import { Produto, ProdutosProps } from 'pages/compra/configuracao-pedido/types';

type ConfigPedidoProdutosModalGrid = {
    open: boolean;
    valueFilter: string;
    produtoMapRef: RefObject<Map<number, ProdutosProps>>;
    selectedMarca: { idMarca: number } | null;
    selectedProduct: Produto | null;
    setSelectedProduct: Dispatch<SetStateAction<Produto | null>>;
};

const columns: GridColDef[] = [
    { field: 'cdProduto', headerName: 'Código', minWidth: 80 },
    { field: 'dsProduto', headerName: 'Descrição', flex: 1, minWidth: 150 },
    { field: 'dsMarca', headerName: 'Marca', minWidth: 120 },
    { field: 'dsGrupo', headerName: 'Categoria', minWidth: 120 },
];

export function ConfigPedidoQuebrasDinamicasModalGrid({
    open,
    selectedMarca,
    valueFilter,
    produtoMapRef,
    selectedProduct,
    setSelectedProduct,
}: ConfigPedidoProdutosModalGrid) {
    const { data, isFetching, refetch } = useQueryProdutosModal({ open, selectedMarca, valueFilter });

    useEffect(() => {
        if (data?.data) {
            data.data.forEach((produto) => produtoMapRef.current.set(produto.idProduto, produto));
        }
    }, [data]);

    const rows = useMemo(() => {
        if (!data?.data) return [];

        return data.data.map((produto) => ({
            id: produto.idProduto,
            cdProduto: produto.cdProduto,
            dsProduto: produto.dsProduto,
            dsMarca: produto.dsMarca,
            dsGrupo: produto.dsGrupo,
        }));
    }, [data]);

    /**
     * Seleciona os produtos clicando na linha.
     */
    const onClickRow = (selectionModel: GridRowSelectionModel) => {
        data?.data?.forEach((produto) => produtoMapRef.current.set(produto.idProduto, produto));

        const ids = Array.from(selectionModel.ids);

        if (!ids.length) {
            setSelectedProduct(null);
            return;
        }

        const id = ids[ids.length - 1] as number;
        const found = produtoMapRef.current.get(id);

        setSelectedProduct(found ? { idProduto: found.idProduto, dsProduto: found.dsProduto, cdProduto: String(found.cdProduto) } : null);
    };

    return (
        <Box sx={{ height: 400 }} onClick={(e) => e.stopPropagation()}>
            <PanelGrid
                checkboxSelection
                autoHeight={false}
                rows={rows}
                rowsCount={data?.total ?? 0}
                columns={columns}
                reload={refetch}
                loading={isFetching}
                onClickRow={onClickRow}
                keepNonExistentRowsSelected
                selectionModel={{
                    type: 'include',
                    ids: new Set(selectedProduct ? [selectedProduct.idProduto] : []),
                }}
            />
        </Box>
    );
}
